import { number, object, string } from 'yup';
import { CreateCommand } from '../../entity/RealtimeEvent.js';
import { RealtimeEventType } from '../../enums.js';

const SCHEMA = object({
  id: string().required(),
  position: number().required(),
  previous_stage_id: string().required(),
  current_stage_id: string().required(),
});

/**
 * CardMoveEvent
 *
 * - Evento emitido quando um card é movido de uma etapa para outra.
 */
export class CardMoveEvent extends CreateCommand(RealtimeEventType.CardMove, SCHEMA) {}
